module.exports = __webpack_public_path__ + "img/vk-full-monochrome.c8e0fd83.svg";